import { createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';


export const createUser = createApiAction(
  types.USER_CREATE,
  (payload) => api.createUser(payload),
);

export const createInvitation = createApiAction(
  types.INVITATION_CREATE,
  (payload) => api.createInvitation(payload),
);
